import { motion } from "framer-motion";
import { PROCESS_STEPS } from "../../data/site";

export default function Process() {
  return (
    <section
      id="process"
      className="py-20 md:py-28 bg-charcoal text-white relative overflow-hidden"
      data-testid="process-section"
    >
      <div className="absolute inset-0 bg-grid-pattern-dark opacity-40 pointer-events-none" />
      {/* Glow accents */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[300px] glow-orb bg-electric/20 pointer-events-none -translate-y-1/2" />

      <div className="container relative">
        <div className="grid lg:grid-cols-12 gap-10 items-end mb-14">
          <div className="lg:col-span-8">
            <p className="text-overline text-electric mb-3">04 — Process</p>
            <h2 className="font-display text-4xl md:text-5xl font-bold text-balance">
              Our Proven Growth Process — From Audit to Revenue
            </h2>
          </div>
          <p className="lg:col-span-4 text-zinc-400 leading-relaxed">
            A repeatable, transparent five-step engine we've used to grow
            revenue for 200+ clients across 15+ industries.
          </p>
        </div>

        <ol className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
          {PROCESS_STEPS.map((s, idx) => {
            const Icon = s.icon;
            return (
              <motion.li
                key={s.title}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: idx * 0.08 }}
                className="bg-white/5 border border-white/8 rounded-2xl p-6 hover:bg-white/10 transition-colors"
                data-testid={`process-step-${idx + 1}`}
              >
                <div className="flex items-center justify-between mb-6">
                  <span className="font-display text-4xl font-bold text-electric/25 leading-none">
                    0{idx + 1}
                  </span>
                  <span className="w-10 h-10 grid place-items-center rounded-xl border border-electric/30 bg-electric/10">
                    <Icon className="w-4 h-4 text-electric" strokeWidth={2} />
                  </span>
                </div>
                <h3 className="font-display text-lg font-semibold">{s.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-zinc-400">
                  {s.text}
                </p>
              </motion.li>
            );
          })}
        </ol>
      </div>
    </section>
  );
}
